import { Component, Inject,Input , Output, ViewChild, OnInit, OnDestroy, NgZone, HostListener, ChangeDetectorRef } from '@angular/core';
import _ from 'lodash';
import {moment} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { DeviceDetectorService } from "ngx-device-detector";
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { BroadCastService } from '../../services/broadcast.service';
import { ExportService } from '../../services/export.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext } from '../../interfaces/mysynch.interfaces';

import {CodeFileItem, HerdFertilityCalendar,  FertilityCalendarItem, FertilityCalendarListItem, GroupTypeMember } from '../../interfaces/mysynch.interfaces';


interface FertilityCalendarOption{
    id: number;
    isSeparator: boolean;
    disabled: boolean;
    displayText: string;
    calendar: HerdFertilityCalendar|null;
}

interface FertilityCalendarEnrollmentFrequencyOption{
    id: number;
    code: string;
    codeValue: string;
    rangeFactor: number;
    sequence: number;
}

interface FertilityCalendarState{
    calendar: HerdFertilityCalendar;
    calendarCollectionIndex: number;
    selectedCalendarOption: FertilityCalendarOption;
    calendarOptionIndex: number;
    selectedLactationGroupOption: GroupTypeMember;
    currentCalendarStartDateString: string | null;
}

@Component({
  standalone: false,
  selector: 'fertility-calendars',
  templateUrl: '../app/pages/fertility-calendars/fertility-calendars.view.html',
  styleUrls:['../app/pages/fertility-calendars/fertility-calendars.style.css']
})
export class FertilityCalendars implements OnInit , OnDestroy {

    @HostListener('window:beforeprint')
    onBeforePrint() {
        this.ngZone.run(()=>{
            this.isExporting = true;
            const calendarName = this.getFormattedCalendarName(this.selectedCalendar.name);
            document.title = `${calendarName}`; 
            this.cdr.detectChanges();
        });
    }

    @HostListener('window:afterprint')
    onAfterPrint() {
        this.ngZone.run(()=>{
            this.isExporting = false;
            document.title = this.originalSiteTitle;
            this.cdr.detectChanges();
        });
    }

    private performanceContext: PerformanceContext | null = null;

    private originalSiteTitle: string = document.title;
    private currentHerdId:number = 0;

    private currentCalendarSeparator: FertilityCalendarOption = {id: 0, isSeparator: true, displayText:"Current Calendars", disabled: true, calendar: null};
    private archivedCalendarSeparator: FertilityCalendarOption = {id: 0, isSeparator: true, displayText:"Archived Calendars", disabled: true, calendar: null};    

    private placeHolderCalender: HerdFertilityCalendar = { id: 0, name: '', lactationGroup: '', startDate: null, startDateString: '', startDOP: 1, fertilityCalendarItems: []} as HerdFertilityCalendar;
    private defaultCalendarName: string = "New Fertility Calendar";

    private defaultLactationGroupMemberCode: string = "1ST";
    private defaultStartDOP: number = 42;
    private defaultEnrollmentFrequencyCode: string = "WEEKLY";

    private heiferDOPType:string = "";
    private heiferGroupTypeMemberId = 3;
    private cowBeforeBreedingDOPType:string = "";
    private cowAfterBreedingDOPType:string = "";

    private fertilityCalendarItemSortOrder: string[] = ['weekNumber','dayOfWeek', 'timeOfDay', 'dayCellIndex'];
    private fertilityCalendarItemSortOrderDirection: string[] = ['asc','asc','asc','asc'];

    private currentTempCalendarId: number = 1000;
    private currentTempCalendarItemId: number = 100000;

     // subscriptions and deregistrations 
    private deregCurrentHerdSubscription:any;
    private deregTransitionOnStart:any;
    
    loading: boolean = true;
    isMobile: boolean;
    isExporting:boolean = false;
    isCreatingNewCalendar: boolean = false;
    isSavingChanges: boolean = false;
    _:any = _;

    archiveModalId: string = "archiveCalendarModal";

    fertilityCalendarListItemClasses: CodeFileItem[] = [];
    calendarListItems: FertilityCalendarListItem[] = [];
    calendars: HerdFertilityCalendar[] = [];
    allFertilityCalendarItems: FertilityCalendarItem[] = [];
    currentMaxHerdFertilityCalendarItemId: number = 0;
    
    calendarSelectOptions: FertilityCalendarOption[] = [];

    selectedCalendarOption: FertilityCalendarOption = null;
    
    selectedCalendarConfig:any = {
        controlId:"selectedCalendar",
        labelProperty:"",
        valueProperty:"calendar",
        orderByField:[""],
        orderByDirection: [""],
        placeholder: "Select Calendar",
        virtualScroll: true
    }
    onSelectedCalendarChange(fertilityCalendarOption:FertilityCalendarOption): void {
        if(!this.selectedCalendarHasChanged){
           this.applySelectedCalendarChanges(fertilityCalendarOption);
        }else{
            this.MSF.confirm(
                {
                    title: `Discard Unsaved Changes?`,
                    message: `There are unsaved changes to the calendar ${_.get(this.selectedCalendar,'name','')} that will be lost. Do you want to continue?`,
                    confirm:{
                        text: "Yes, Discard Changes",
                        className:"danger",
                        icon: "trash"
                    }
                }
                ,()=>{
                    // confirm
                    // revert changes to the previous calendar
                    this.onCancelCalendarChanges();
                    // update the calendar option
                    const indexOfPreviouslySelectedCalendarOption = _.findIndex(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});
                    if(indexOfPreviouslySelectedCalendarOption > -1){
                         this.calendarSelectOptions = [
                        ...this.calendarSelectOptions.slice(0, indexOfPreviouslySelectedCalendarOption),
                        _.cloneDeep(this.originalSelectedCalendarOption),
                        ...this.calendarSelectOptions.slice(indexOfPreviouslySelectedCalendarOption + 1)
                      ];
                    }
                    // then apply the newly selected calendar changes
                    this.applySelectedCalendarChanges(fertilityCalendarOption);
                } 
                ,()=>{ 
                    // cancel 
                    this.selectedCalendarOption = _.cloneDeep(this.selectedCalendarOption);
                } 
            );

        }
    }


    lactationGroupOptions: GroupTypeMember[] = [];
    selectedLactationGroupOption: GroupTypeMember = null;
    selectedLactationGroupConfig:any = {
        controlId:"selectedLactationGroup",
        labelProperty:"groupMember",
        valueProperty:"groupMemberCode",
        orderByField:["sequence"],
        orderByDirection: ["asc"],
        placeholder: "Select Lactation Group",
        virtualScroll: true
    }
    onSelectedLactationGroupChange(lactationGroupOption:GroupTypeMember): void {
        this.selectedLactationGroupOption = lactationGroupOption;
        this.ngZone.run(()=>{
       
            this.updateCalendarPropertyState('lactationGroup', lactationGroupOption.groupMember);
            this.setDOPLabel();
       
        });
    }

    enrollmentFrequencyOptions: FertilityCalendarEnrollmentFrequencyOption[] = [];
    selectedEnrollmentFrequencyOption: FertilityCalendarEnrollmentFrequencyOption = null;
    selectedEnrollmentFrequencyConfig:any = {
        controlId:"selectedEnrollmentFrequency",
        labelProperty:"codeValue",
        valueProperty:"code",
        orderByField:["dropDownSeq"],
        orderByDirection: ["asc"],
        placeholder: "Select Enrollment Frequency",
        virtualScroll: true
    }
    onSelectedEnrollmentFrequencyChange(enrollmentFrequencyOption:FertilityCalendarEnrollmentFrequencyOption): void {
        this.selectedEnrollmentFrequencyOption = enrollmentFrequencyOption;
        this.ngZone.run(()=>{
           
            this.updateCalendarPropertyState('enrollmentFrequencyCode', enrollmentFrequencyOption.code);
            this.updateCalendarPropertyState('enrollmentFrequency', enrollmentFrequencyOption.codeValue);
        });
    }

    originalSelectedCalendarOptionIndex: number = null;
    originalSelectedCalendarOption: FertilityCalendarOption = null;
    originalSelectedLactationGroupOption: GroupTypeMember = null;
    originalSelectedEnrollmentFrequencyOption: FertilityCalendarEnrollmentFrequencyOption = null;
    
    originalCalendarsItemIndex: number = null;
    originalSelectedCalendar: HerdFertilityCalendar = null;
    selectedCalendar: HerdFertilityCalendar = null;
    selectedCalendarHasChanged: boolean = false;
    //properties that require additional action before updating the selectedCalendar object
    currentCalendarStartDateString: string | null = null;
    currentDOPType: string = "DIM";

    selectedCalendarNameIsValid: boolean = true;
    selectedCalendarStartDateIsValid: boolean = true;
    selectedCalendarStartDOPIsValid: boolean = true;
    selectedCalendarEndDateIsValid: boolean = true;

    constructor(
       @Inject('MySynchFactory') private MSF:any,
       @Inject('ApiFactory') private api:any,
       @Inject('$transitions') private $transitions,
       @Inject(DeviceDetectorService) private deviceDetectorSvc:DeviceDetectorService,
       @Inject(MySynchConstantService) protected mySynchConstantService: MySynchConstantService,
       @Inject(ExportService) private exportService: ExportService,
       @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
       @Inject(BroadCastService) private broadcastSvc:BroadCastService,    
       @Inject(NgZone) private ngZone:NgZone,
       @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
       @Inject(PerformanceMetricsService) private perfMetricSvc:any,
       @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
       @Inject(ClientLoggerService) private log:ClientLoggerService,
    ) {
        this.isMobile = this.deviceDetectorSvc.isMobile();
    }

    ngOnInit() {
        this.MSF.ready(() => {
            this.deregTransitionOnStart = this.$transitions.onStart({}, this.routeChange.bind(this));
            this.currentHerdId = _.get(this.MSF.getActiveHerd(), 'herdId', 0);
            this.performanceContext = this.perfContextSvc.createPerformanceContext(this.currentHerdId);
            this.perfMetricSvc.startTiming('Page:FertilityCalendars:Render');
            this.loadPage().then(()=>{
                this.perfMetricSvc.markPageReady('Page:FertilityCalendars:Render', this.performanceContext);
            });
            this.deregCurrentHerdSubscription = this.mysynchDataStore.currentActiveHerd
            .subscribe((herd)=>{
                if(!this.MSF.isNullish(herd) && !this.loading) {
                    this.loading = true;
                    this.currentHerdId = _.get(this.MSF.getActiveHerd(), 'herdId', 0);
                    this.performanceContext = this.perfContextSvc.createPerformanceContext(this.currentHerdId);
                    this.perfMetricSvc.startTiming('Page:FertilityCalendars:Render');
                    this.resetCalendarPageState();
                    this.loadPage().then(()=>{
                        this.perfMetricSvc.markPageReady('Page:FertilityCalendars:Render', this.performanceContext);
                    });

                }
            });
            
        });
    }

    ngOnDestroy() {
        if(this.deregCurrentHerdSubscription){
            this.deregCurrentHerdSubscription.unsubscribe();
        }

        if(this.deregTransitionOnStart){
            this.deregTransitionOnStart();
        }
        this.performanceContext = null;
    }

    

    private resetCalendarPageState(): void {
        this.isCreatingNewCalendar = false;
        this.isSavingChanges = false;
        this.isExporting = false;
        this.selectedCalendarHasChanged = false;
        this.selectedCalendarNameIsValid = true;
        this.selectedCalendarStartDateIsValid = true;
        this.selectedCalendarStartDOPIsValid = true;
        this.selectedCalendarEndDateIsValid = true;
        this.currentTempCalendarId = 1000;
        this.currentTempCalendarItemId = 100000;
        this.fertilityCalendarListItemClasses = [] as CodeFileItem[];
        this.calendarListItems = [] as FertilityCalendarListItem[];
        this.calendars = [] as HerdFertilityCalendar[];
        this.allFertilityCalendarItems = [] as FertilityCalendarItem[];
    }

    private loadPage(): Promise<void> {

        return new Promise<void>((resolve, reject) => {
            this.perfMetricSvc.startTiming('Page:FertilityCalendars:Request');
            this.api.getHerdFertilityCalendarsByHerdId(this.currentHerdId, (err, calendars)=>{
                this.perfMetricSvc.endTiming("page",'Page:FertilityCalendars:Request', this.performanceContext);
                if (err) {
                    this.log.error('Error getting Fertility Calendar data: ' + err);
                }
                this.perfMetricSvc.startTiming('Page:FertilityCalendars:Build');
                this.loadFertilityCalendarItemClasses();
                this.loadLactationGroupOptions();
                this.loadEnrollmentFrequencyOptions();
                this.loadCalendarListItems();

                const codeFileDOPTypes = _.filter(this.MSF.lists.codeFile, {codeType: 'DOPTYPES'}) as CodeFileItem[];
                this.heiferDOPType = _.get(_.find(codeFileDOPTypes, {code: 'HEIFER'}), 'codeValue', '');
                this.cowBeforeBreedingDOPType = _.get(_.find(codeFileDOPTypes, {code: 'COWBEFOREBREED'}), 'codeValue', '');
                this.cowAfterBreedingDOPType = _.get(_.find(codeFileDOPTypes, {code: 'COWAFTERBREED'}), 'codeValue', '');
                
                if(_.get(calendars,'length',0) > 0){
                    
                    // calendar fertility calendar items come in as json 
                    _.forEach(calendars, (calendar)=>{
                        let startDateMoment = moment(_.get(calendar,'startDate'), 'YYYY-MM-DD');
                    
                        _.set(calendar,'startDate', startDateMoment.toDate());
                        _.set(calendar,'startDateString', startDateMoment.format('YYYY-MM-DD'));
                        if(!_.isNull(_.get(calendar,'archivedDate'))){
                            let archivedDateMoment = moment(_.get(calendar,'archivedDate'), 'YYYY-MM-DD');
                            _.set(calendar,'archivedDate', archivedDateMoment.toDate());
                            _.set(calendar,'archivedDateString', archivedDateMoment.format('YYYY-MM-DD'));
                        }
                        if(!_.isNull(_.get(calendar,'endDate'))){
                            let endDateMoment = moment(_.get(calendar,'endDate'), 'YYYY-MM-DD');
                            _.set(calendar,'endDate', endDateMoment.toDate());
                            _.set(calendar,'endDateString', endDateMoment.format('YYYY-MM-DD'));
                        }

                        _.set(calendar,'enrollmentFrequency', _.get(_.find(this.enrollmentFrequencyOptions, {code: calendar.enrollmentFrequencyCode}), 'codeValue', ''));

                        try{
                            let fertilityItems = JSON.parse(_.get(calendar,'fertilityCalendarItems', '[]'));
                            fertilityItems = _.map(fertilityItems, this.MSF.lowerCaseObjectKeys) as FertilityCalendarItem[];
                            _.forEach(fertilityItems, (item)=>{
                                const calendarListItemClassCode = _.get(item,'classCode');
                                const calendarListItemClass = _.find(this.fertilityCalendarListItemClasses, {code: calendarListItemClassCode}) as CodeFileItem;
                                _.set(item,'class', _.get(calendarListItemClass,'codeValue',''));
                            });
                            _.set(calendar,'fertilityCalendarItems', fertilityItems);
                            this.allFertilityCalendarItems = this.allFertilityCalendarItems.concat(fertilityItems);
                        }catch(e){
                            this.log.error('Error parsing calendar fertility items: ' + e, {error:e, calendar: calendar});
                            _.set(calendar,'fertilityCalendarItems', []);
                        }
                    });
                    this.calendars = calendars as HerdFertilityCalendar[];
                }
                    this.currentMaxHerdFertilityCalendarItemId = _.max(_.map(this.allFertilityCalendarItems, (item)=>_.get(item,'herdFertilityCalendarItemId',0))) || 0;
                    this.loadCalendarOptions();
                    this.initializeSelectedCalendar();
                    this.currentCalendarStartDateString = this.selectedCalendar ? _.get(this.selectedCalendar, 'startDateString') : null;
                    this.setDOPLabel();

                    
                // }else{
                //     this.calendars = [];
                //     this.selectedCalendar = _.cloneDeep(this.placeHolderCalender);
                // }
                this.initializeLactationGroupOption();
                this.initializeEnrollmentFrequencyOption();
                // this.loadLactationGroupOptions();
                // this.loadEnrollmentFrequencyOptions();
                // this.loadCalendarListItems();

                this.loading = false;
                this.perfMetricSvc.endTiming("page",'Page:FertilityCalendars:Build', this.performanceContext);
                resolve();
            });
        });

    }


    private getNextTempCalendarId(): number {
        this.currentTempCalendarId += 1;
        return this.currentTempCalendarId;
    }

    private getNextTempCalendarItemId(): number {
        this.currentTempCalendarItemId += 1;
        return this.currentTempCalendarItemId;
    }
    private getCalendarDisplayText(calendar: HerdFertilityCalendar): string {
        const calendarName =  _.get(calendar,'name') as string;
        const lactationGroup =  _.get(calendar,'lactationGroup') as string;
        const startDate =  _.get(calendar,'startDate') as Date;
        const startDOP =  _.get(calendar,'startDOP') as number;
        const isArchived =  _.get(calendar,'isArchived') as boolean;
        const archivedDate =  _.get(calendar,'archivedDate') as Date;

        let calendarDisplayText = calendarName;
        let calendarInfoText = ` ( ${lactationGroup} : ${moment(startDate).format('MM/DD/YYYY')})`; 
        if(isArchived){
            calendarInfoText = ` ( ${lactationGroup} : Archived On: ${moment(archivedDate).format('MM/DD/YYYY')} )`;
        }
        calendarDisplayText += ' ' + calendarInfoText;
        return calendarDisplayText;
    }

    private applySelectedCalendarChanges(fertilityCalendarOption: FertilityCalendarOption): void {
        this.selectedCalendarOption = fertilityCalendarOption;
            this.selectedCalendar = fertilityCalendarOption.calendar;

            this.originalSelectedCalendar = _.cloneDeep(this.selectedCalendar);
            this.originalCalendarsItemIndex = _.findIndex(this.calendars, {id: this.selectedCalendar.id});
            this.originalSelectedCalendarOption = _.cloneDeep(this.selectedCalendarOption);
            this.originalSelectedCalendarOptionIndex = _.findIndex(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});

            this.setSelectedLactationGroupOption(this.selectedCalendar?.lactationGroup);
            this.originalSelectedLactationGroupOption = _.cloneDeep(this.selectedLactationGroupOption);
            this.currentCalendarStartDateString = this.selectedCalendar ? _.get(this.selectedCalendar, 'startDateString') : null;
            this.setDOPLabel();
            this.setSelectedEnrollmentFrequencyOption(this.selectedCalendar?.enrollmentFrequencyCode);
            this.originalSelectedEnrollmentFrequencyOption = _.cloneDeep(this.selectedEnrollmentFrequencyOption);
    }
    
    private setSelectedLactationGroupOption(lactationGroup: string): void {
        const selectedLactationGroupOption = _.find(this.lactationGroupOptions, {groupMember: lactationGroup}) as GroupTypeMember;
        this.selectedLactationGroupOption = selectedLactationGroupOption;

    }

    private setSelectedEnrollmentFrequencyOption(enrollmentFrequencyCode: string): void {
        const selectedEnrollmentFrequencyOption = _.find(this.enrollmentFrequencyOptions, {code: enrollmentFrequencyCode}) as FertilityCalendarEnrollmentFrequencyOption;
        this.selectedEnrollmentFrequencyOption = selectedEnrollmentFrequencyOption;
    }

    private getFertilityCalendarListItemForCalendarItem(classCode: string): any {
        return  _(_.find(this.calendarListItems, {classCode: classCode}))
                .pick(['id','text','description','class','classCode'])
                .mapKeys((value, key)=>(key === 'id' ? 'herdFertilityCalendarItemListId' : key))
                .value();
    }


    private getTemplateCalendars(): HerdFertilityCalendar[] {

        const GONAbreedCalendarListItem:any = this.getFertilityCalendarListItemForCalendarItem('BLUE');
        const estroPLANCalendarListItem:any = this.getFertilityCalendarListItemForCalendarItem('RED');
        const VWPCalendarListItem:any = this.getFertilityCalendarListItemForCalendarItem('LIGHTGREEN');
        const TAICalendarListItem:any = this.getFertilityCalendarListItemForCalendarItem('YELLOW');
        const PGChkCalendarListItem:any = this.getFertilityCalendarListItemForCalendarItem('BLACK');

        const templateCalendar1 = {
            id: -1,
            name: 'TEMPLATE: 14-11 Presynch Ovsynch',
            lactationGroup: 'All Cows (LACT>0)',
            startDate: new Date( 2026,2,1), // month is 0 indexed in js date
            startDateString: moment(new Date( 2026,2,1)).format('YYYY-MM-DD'),
            endDate: null,
            endDateString: null,
            startDOP: 35,
            enrollmentFrequencyCode: 'WEEKLY',
            enrollmentFrequency: "Weekly",
            isArchived: false,
            archivedDate: null,
            archivedDateString: null,
            fertilityCalendarItems: [
                 {id: -1, herdId: this.currentHerdId, herdFertilityCalendarItemId: -1, herdFertilityCalendarId: -1, weekNumber: 1, dayOfWeek: 5, timeOfDay: 'AM', dOP: 35, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -2, herdId: this.currentHerdId, herdFertilityCalendarItemId: -2, herdFertilityCalendarId: -1, weekNumber: 3, dayOfWeek: 5, timeOfDay: 'AM', dOP: 49, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -3, herdId: this.currentHerdId, herdFertilityCalendarItemId: -3, herdFertilityCalendarId: -1, weekNumber: 5, dayOfWeek: 2, timeOfDay: 'AM', dOP: 60, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -4, herdId: this.currentHerdId, herdFertilityCalendarItemId: -4, herdFertilityCalendarId: -1, weekNumber: 6, dayOfWeek: 2, timeOfDay: 'AM', dOP: 67, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -5, herdId: this.currentHerdId, herdFertilityCalendarItemId: -5, herdFertilityCalendarId: -1, weekNumber: 6, dayOfWeek: 3, timeOfDay: 'AM', dOP: 68, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -6, herdId: this.currentHerdId, herdFertilityCalendarItemId: -6, herdFertilityCalendarId: -1, weekNumber: 6, dayOfWeek: 4, timeOfDay: 'PM', dOP: 69, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -7, herdId: this.currentHerdId, herdFertilityCalendarItemId: -7, herdFertilityCalendarId: -1, weekNumber: 6, dayOfWeek: 5, timeOfDay: 'AM', dOP: 70, dOPType: "DIM", dayCellIndex: 0, ...VWPCalendarListItem} as FertilityCalendarItem
                ,{id: -8, herdId: this.currentHerdId, herdFertilityCalendarItemId: -8, herdFertilityCalendarId: -1, weekNumber: 6, dayOfWeek: 5, timeOfDay: 'AM', dOP: 70, dOPType: "DIM", dayCellIndex: 1, ...TAICalendarListItem} as FertilityCalendarItem
                ,{id: -9, herdId: this.currentHerdId, herdFertilityCalendarItemId: -9, herdFertilityCalendarId: -1, weekNumber: 11, dayOfWeek: 2, timeOfDay: 'AM', dOP: 32, dOPType: "DSLH", dayCellIndex: 0, ...PGChkCalendarListItem} as FertilityCalendarItem
                ,{id: -10, herdId: this.currentHerdId, herdFertilityCalendarItemId: -10, herdFertilityCalendarId: -1, weekNumber: 11, dayOfWeek: 2, timeOfDay: 'AM', dOP: 32, dOPType: "DSLH", dayCellIndex: 1, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -11, herdId: this.currentHerdId, herdFertilityCalendarItemId: -11, herdFertilityCalendarId: -1, weekNumber: 12, dayOfWeek: 2, timeOfDay: 'AM', dOP: 39, dOPType: "DSLH", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -12, herdId: this.currentHerdId, herdFertilityCalendarItemId: -12, herdFertilityCalendarId: -1, weekNumber: 12, dayOfWeek: 3, timeOfDay: 'AM', dOP: 40, dOPType: "DSLH", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -13, herdId: this.currentHerdId, herdFertilityCalendarItemId: -13, herdFertilityCalendarId: -1, weekNumber: 12, dayOfWeek: 4, timeOfDay: 'PM', dOP: 41, dOPType: "DSLH", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -14, herdId: this.currentHerdId, herdFertilityCalendarItemId: -14, herdFertilityCalendarId: -1, weekNumber: 12, dayOfWeek: 5, timeOfDay: 'AM', dOP: 42, dOPType: "DSLH", dayCellIndex: 0, ...TAICalendarListItem} as FertilityCalendarItem
                
            ],
            isTemplate: true
        } as HerdFertilityCalendar;
        
        const templateCalendar2 = {
            id: -2,
           name: 'TEMPLATE: Double Ovsynch',
            lactationGroup: 'All Cows (LACT>0)',
            startDate: new Date( 2026,2,1), // month is 0 indexed in js date
            startDateString: moment(new Date( 2026,2,1)).format('YYYY-MM-DD'),
            endDate: null,
            endDateString: null,
            startDOP: 43,
            enrollmentFrequencyCode: 'WEEKLY',
            enrollmentFrequency: "Weekly",
            isArchived: false,
            archivedDate: null,
            archivedDateString: null,
            fertilityCalendarItems: [
                 {id: -15, herdId: this.currentHerdId, herdFertilityCalendarItemId: -15, herdFertilityCalendarId: -2, weekNumber: 1, dayOfWeek: 6, timeOfDay: 'AM', dOP: 43, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -16, herdId: this.currentHerdId, herdFertilityCalendarItemId: -16, herdFertilityCalendarId: -2, weekNumber: 2, dayOfWeek: 6, timeOfDay: 'AM', dOP: 50, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -17, herdId: this.currentHerdId, herdFertilityCalendarItemId: -17, herdFertilityCalendarId: -2, weekNumber: 3, dayOfWeek: 2, timeOfDay: 'AM', dOP: 53, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -18, herdId: this.currentHerdId, herdFertilityCalendarItemId: -18, herdFertilityCalendarId: -2, weekNumber: 4, dayOfWeek: 2, timeOfDay: 'AM', dOP: 60, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -19, herdId: this.currentHerdId, herdFertilityCalendarItemId: -19, herdFertilityCalendarId: -2, weekNumber: 5, dayOfWeek: 2, timeOfDay: 'AM', dOP: 67, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -20, herdId: this.currentHerdId, herdFertilityCalendarItemId: -20, herdFertilityCalendarId: -2, weekNumber: 5, dayOfWeek: 3, timeOfDay: 'AM', dOP: 68, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -21, herdId: this.currentHerdId, herdFertilityCalendarItemId: -21, herdFertilityCalendarId: -2, weekNumber: 5, dayOfWeek: 4, timeOfDay: 'PM', dOP: 69, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -22, herdId: this.currentHerdId, herdFertilityCalendarItemId: -22, herdFertilityCalendarId: -2, weekNumber: 5, dayOfWeek: 5, timeOfDay: 'AM', dOP: 70, dOPType: "DIM", dayCellIndex: 0, ...VWPCalendarListItem} as FertilityCalendarItem
                ,{id: -23, herdId: this.currentHerdId, herdFertilityCalendarItemId: -23, herdFertilityCalendarId: -2, weekNumber: 5, dayOfWeek: 5, timeOfDay: 'AM', dOP: 70, dOPType: "DIM", dayCellIndex: 1, ...TAICalendarListItem} as FertilityCalendarItem
                ,{id: -24, herdId: this.currentHerdId, herdFertilityCalendarItemId: -24, herdFertilityCalendarId: -2, weekNumber: 10, dayOfWeek: 2, timeOfDay: 'AM', dOP: 32, dOPType: "DSLH", dayCellIndex: 0, ...PGChkCalendarListItem} as FertilityCalendarItem
                ,{id: -25, herdId: this.currentHerdId, herdFertilityCalendarItemId: -25, herdFertilityCalendarId: -2, weekNumber: 10, dayOfWeek: 2, timeOfDay: 'AM', dOP: 32, dOPType: "DSLH", dayCellIndex: 1, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -26, herdId: this.currentHerdId, herdFertilityCalendarItemId: -26, herdFertilityCalendarId: -2, weekNumber: 11, dayOfWeek: 2, timeOfDay: 'AM', dOP: 39, dOPType: "DSLH", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -27, herdId: this.currentHerdId, herdFertilityCalendarItemId: -27, herdFertilityCalendarId: -2, weekNumber: 11, dayOfWeek: 3, timeOfDay: 'AM', dOP: 40, dOPType: "DSLH", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -28, herdId: this.currentHerdId, herdFertilityCalendarItemId: -28, herdFertilityCalendarId: -2, weekNumber: 11, dayOfWeek: 4, timeOfDay: 'PM', dOP: 41, dOPType: "DSLH", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -29, herdId: this.currentHerdId, herdFertilityCalendarItemId: -29, herdFertilityCalendarId: -2, weekNumber: 11, dayOfWeek: 5, timeOfDay: 'AM', dOP: 42, dOPType: "DSLH", dayCellIndex: 0, ...TAICalendarListItem} as FertilityCalendarItem
            ],
            isTemplate: true
        } as HerdFertilityCalendar;

        const templateCalendar3 = {
            id: -3,
           name: 'TEMPLATE: G6G',
            lactationGroup: 'All Cows (LACT>0)',
            startDate: new Date( 2026,2,1), // month is 0 indexed in js date
            startDateString: moment(new Date( 2026,2,1)).format('YYYY-MM-DD'),
            endDate: null,
            endDateString: null,
            startDOP: 52,
            enrollmentFrequencyCode: 'WEEKLY',
            enrollmentFrequency: "Weekly",
            isArchived: false,
            archivedDate: null,
            archivedDateString: null,
            fertilityCalendarItems: [
                 {id: -30, herdId: this.currentHerdId, herdFertilityCalendarItemId: -30, herdFertilityCalendarId: -3, weekNumber: 1, dayOfWeek: 2, timeOfDay: 'AM', dOP: 52, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -31, herdId: this.currentHerdId, herdFertilityCalendarItemId: -31, herdFertilityCalendarId: -3, weekNumber: 1, dayOfWeek: 4, timeOfDay: 'AM', dOP: 54, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -32, herdId: this.currentHerdId, herdFertilityCalendarItemId: -32, herdFertilityCalendarId: -3, weekNumber: 2, dayOfWeek: 3, timeOfDay: 'AM', dOP: 60, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -33, herdId: this.currentHerdId, herdFertilityCalendarItemId: -33, herdFertilityCalendarId: -3, weekNumber: 3, dayOfWeek: 3, timeOfDay: 'AM', dOP: 67, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -34, herdId: this.currentHerdId, herdFertilityCalendarItemId: -34, herdFertilityCalendarId: -3, weekNumber: 3, dayOfWeek: 4, timeOfDay: 'AM', dOP: 68, dOPType: "DIM", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -35, herdId: this.currentHerdId, herdFertilityCalendarItemId: -35, herdFertilityCalendarId: -3, weekNumber: 3, dayOfWeek: 5, timeOfDay: 'PM', dOP: 69, dOPType: "DIM", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -36, herdId: this.currentHerdId, herdFertilityCalendarItemId: -36, herdFertilityCalendarId: -3, weekNumber: 3, dayOfWeek: 6, timeOfDay: 'AM', dOP: 70, dOPType: "DIM", dayCellIndex: 0, ...TAICalendarListItem} as FertilityCalendarItem
                ,{id: -37, herdId: this.currentHerdId, herdFertilityCalendarItemId: -37, herdFertilityCalendarId: -3, weekNumber: 8, dayOfWeek: 3, timeOfDay: 'AM', dOP: 32, dOPType: "DSLH", dayCellIndex: 0, ...PGChkCalendarListItem} as FertilityCalendarItem
                ,{id: -38, herdId: this.currentHerdId, herdFertilityCalendarItemId: -38, herdFertilityCalendarId: -3, weekNumber: 8, dayOfWeek: 3, timeOfDay: 'AM', dOP: 32, dOPType: "DSLH", dayCellIndex: 1, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -39, herdId: this.currentHerdId, herdFertilityCalendarItemId: -39, herdFertilityCalendarId: -3, weekNumber: 9, dayOfWeek: 3, timeOfDay: 'AM', dOP: 39, dOPType: "DSLH", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -40, herdId: this.currentHerdId, herdFertilityCalendarItemId: -40, herdFertilityCalendarId: -3, weekNumber: 9, dayOfWeek: 4, timeOfDay: 'AM', dOP: 40, dOPType: "DSLH", dayCellIndex: 0, ...estroPLANCalendarListItem} as FertilityCalendarItem
                ,{id: -41, herdId: this.currentHerdId, herdFertilityCalendarItemId: -41, herdFertilityCalendarId: -3, weekNumber: 9, dayOfWeek: 5, timeOfDay: 'PM', dOP: 41, dOPType: "DSLH", dayCellIndex: 0, ...GONAbreedCalendarListItem} as FertilityCalendarItem
                ,{id: -42, herdId: this.currentHerdId, herdFertilityCalendarItemId: -42, herdFertilityCalendarId: -3, weekNumber: 9, dayOfWeek: 6, timeOfDay: 'AM', dOP: 42, dOPType: "DSLH", dayCellIndex: 0, ...TAICalendarListItem} as FertilityCalendarItem

            ],
            isTemplate: true
        } as HerdFertilityCalendar;
        return [templateCalendar1, templateCalendar2, templateCalendar3];
    }
            

    private loadFertilityCalendarItemClasses(): void {
        const codeFileFertCalItemClasses = _.filter(_.get(this.MSF,'lists.codeFile',[]), {codeType: 'FERTCALCSSCLS'}) as CodeFileItem[];
        this.fertilityCalendarListItemClasses = _.map(codeFileFertCalItemClasses, (codeFileItem)=>{
            return {
                id: codeFileItem.id,
                codeType: codeFileItem.codeType,
                code: codeFileItem.code,
                codeValue: codeFileItem.codeValue,
                dropDownSeq: codeFileItem.dropDownSeq,
                detailsJson: codeFileItem.detailsJson
            } as CodeFileItem;
        });

    }

    private loadCalendarListItems(): void {
        let calendarListItems  = _.get(this.MSF,'lists.herdFertilityCalendarItemList', []) as FertilityCalendarListItem[];
        _.forEach(calendarListItems, (item)=>{
            const calendarListItemClassCode = _.get(item,'classCode');
            const calendarListItemClass = _.find(this.fertilityCalendarListItemClasses, {code: calendarListItemClassCode}) as CodeFileItem;
            _.set(item,'class', _.get(calendarListItemClass,'codeValue',''));
        });
        this.calendarListItems = _.sortByOrder(calendarListItems, ['sequence'], ['asc']);
    }
    private loadCalendarOptions(): void {

        let calendarSelectOptions: FertilityCalendarOption[] = [];

        // Add template calendars to options list
        const templateCalendars = this.getTemplateCalendars();
        _.forEach(templateCalendars, (calendar)=>{
            let calendarOption: FertilityCalendarOption = {
                id: calendar.id,
                isSeparator: false,
                disabled: false,
                displayText: this.getCalendarDisplayText(calendar),
                calendar: calendar
            };
            calendarSelectOptions.push(calendarOption);
        });
        
        _.forEach(this.calendars, (calendar)=>{
            let calendarOption: FertilityCalendarOption = {
                id: calendar.id,
                isSeparator: false,
                disabled: false,
                displayText: this.getCalendarDisplayText(calendar),
                calendar: calendar
            };
            calendarSelectOptions.push(calendarOption);
        });
        

        const currentCalendarsOptions = _.filter(calendarSelectOptions, {calendar:{isArchived: false}});
        const archivedCalendarsOptions = _.filter(calendarSelectOptions, {calendar:{isArchived: true}});

        this.calendarSelectOptions = [this.currentCalendarSeparator, ...currentCalendarsOptions, this.archivedCalendarSeparator, ...archivedCalendarsOptions];

       this.sortSelectCalendarOptions();

       
    }

    private sortSelectCalendarOptions(): void {
        const currentCalendars = _.filter(this.calendarSelectOptions, {calendar:{ isArchived: false}});
        const archivedCalendars = _.filter(this.calendarSelectOptions, {calendar:{ isArchived: true}});
        const sortedCurrentCalendars = _.sortByOrder(currentCalendars, ['calendar.name'], ['asc']);
        const sortedArchivedCalendars = _.sortByOrder(archivedCalendars, ['calendar.name'], ['asc']);
        this.calendarSelectOptions = [this.currentCalendarSeparator, ...sortedCurrentCalendars, this.archivedCalendarSeparator, ...sortedArchivedCalendars];
    }
    private loadLactationGroupOptions(): void {
        const lactGroupMembers = _.filter(_.get(this.MSF,'lists.groupTypeMembers',[]),{groupTypeCode:"LACTGROUP-SETCSV"}) as GroupTypeMember[]; 
        
        this.lactationGroupOptions = _.sortByOrder(_.map(lactGroupMembers, (member)=>{
                                                    return {
                                                        id: member.id,
                                                        groupTypeCode: member.groupTypeCode,
                                                        groupMember: member.groupMember,
                                                        groupMemberCode: member.groupMemberCode,
                                                        sequence: member.sequence,
                                                    };
                                                }) as GroupTypeMember[]
                                 , ['sequence'], ['asc']);

    }

    private initializeLactationGroupOption(): void {
        const selectedCalendarLactationGroup = _.get(this.selectedCalendar,'lactationGroup');
        let initialSelectedLactationGroupOption = _.first(this.lactationGroupOptions);
        if(!_.isUndefined(selectedCalendarLactationGroup)){
            initialSelectedLactationGroupOption = _.find(this.lactationGroupOptions, {groupMember: selectedCalendarLactationGroup}) as GroupTypeMember;
        }

        this.selectedLactationGroupOption = initialSelectedLactationGroupOption;

        this.originalSelectedLactationGroupOption = _.cloneDeep(this.selectedLactationGroupOption);
    }

    private loadEnrollmentFrequencyOptions(): void {
        const enrollmentFrequencyOptions = this.MSF.getCodeFileSubsetWithParsedDetailsJson(_.filter(_.get(this.MSF,'lists.codeFile',[]), {codeType: 'CALENROLLFRQS'})) as CodeFileItem[];
        this.enrollmentFrequencyOptions = _.sortByOrder(_.map(enrollmentFrequencyOptions, (option)=>{
                                                            return {
                                                                id: option.id,
                                                                code: option.code,
                                                                codeValue: option.codeValue,
                                                                rangeFactor: _.get(option,'detailsJson.rangeFactor', 0),
                                                                sequence: option.dropDownSeq
                                                            } as FertilityCalendarEnrollmentFrequencyOption;
                                                        }) as FertilityCalendarEnrollmentFrequencyOption[]
                                         , ['sequence'], ['asc']);
    }

    private initializeEnrollmentFrequencyOption(): void {
        const selectedCalendarEnrollmentFrequencyCode = _.get(this.selectedCalendar,'enrollmentFrequencyCode');
        let initialSelectedEnrollmentFrequencyOption = _.first(this.enrollmentFrequencyOptions);
        if(!_.isUndefined(selectedCalendarEnrollmentFrequencyCode)){
            initialSelectedEnrollmentFrequencyOption = _.find(this.enrollmentFrequencyOptions, {code: selectedCalendarEnrollmentFrequencyCode}) as FertilityCalendarEnrollmentFrequencyOption;
        }
        this.selectedEnrollmentFrequencyOption = initialSelectedEnrollmentFrequencyOption;
        this.originalSelectedEnrollmentFrequencyOption = _.cloneDeep(this.selectedEnrollmentFrequencyOption);
    }

    private initializeSelectedCalendar(): void {
         let initialSelectedCalendarOption = _.first(_.filter(this.calendarSelectOptions,{calendar:{isArchived: false}}));
        if(_.isUndefined(initialSelectedCalendarOption)){
            initialSelectedCalendarOption = _.first(_.filter(this.calendarSelectOptions,{calendar:{isArchived: true}}));
        }
       
        this.selectedCalendarOption = initialSelectedCalendarOption;
        this.selectedCalendar = initialSelectedCalendarOption.calendar;
        this.originalSelectedCalendar = _.cloneDeep(this.selectedCalendar);
        this.originalCalendarsItemIndex = _.findIndex(this.calendars, {id: this.selectedCalendar.id});
        this.originalSelectedCalendarOption = _.cloneDeep(this.selectedCalendarOption);
        this.originalSelectedCalendarOptionIndex = _.findIndex(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});
    }

    private selectCalendar(calendar: HerdFertilityCalendar): void {
        const calendarOption = _.find(this.calendarSelectOptions, {calendar: {id: calendar.id}}) as FertilityCalendarOption;
       
        this.selectedCalendarOption = calendarOption;
        this.selectedCalendar = calendar;
        this.setSelectedLactationGroupOption(this.selectedCalendar?.lactationGroup);
        this.currentCalendarStartDateString = this.selectedCalendar ? _.get(this.selectedCalendar, 'startDateString') : null;
        this.setSelectedEnrollmentFrequencyOption(this.selectedCalendar?.enrollmentFrequencyCode);
        this.setDOPLabel();
         if(!this.isCreatingNewCalendar){
            this.originalSelectedCalendar = _.cloneDeep(calendar);
            this.originalCalendarsItemIndex = _.findIndex(this.calendars, {id: calendar.id});
            this.originalSelectedCalendarOption = _.cloneDeep(calendarOption);
            this.originalSelectedCalendarOptionIndex = _.findIndex(this.calendarSelectOptions, {id: calendarOption.id});
            this.originalSelectedLactationGroupOption = _.cloneDeep(this.selectedLactationGroupOption);
            this.originalSelectedEnrollmentFrequencyOption = _.cloneDeep(this.selectedEnrollmentFrequencyOption);
         }
          
    }

    private setDOPLabel():void{
        const heiferGroupMember = _.get(_.find(this.lactationGroupOptions, {id: this.heiferGroupTypeMemberId}), 'groupMember', null);
        if(heiferGroupMember && _.get(this.selectedCalendar,'lactationGroup') === heiferGroupMember){
            this.currentDOPType = this.heiferDOPType;
        }else{
            this.currentDOPType = this.cowBeforeBreedingDOPType;
        }
    }
     private updateSelectedCalendarState(updatedCalendar: HerdFertilityCalendar): void {
        this.ngZone.run(()=>{
            _.set(this.selectedCalendarOption, 'displayText', this.getCalendarDisplayText(updatedCalendar));
            this.selectedCalendar =  {...updatedCalendar}; //_.cloneDeep(updatedCalendar);
            this.selectedCalendarHasChanged = this.hasSelectedCalendarChanged();
        });
    }
    
    private hasCalendarItemsChanged(): boolean {
        const selectedItems = this.selectedCalendar?.fertilityCalendarItems || [];
        const originalItems = this.originalSelectedCalendar?.fertilityCalendarItems || [];
        
        if (selectedItems.length !== originalItems.length) {
            return true;
        }
        
        // Sort by ID to ensure consistent comparison order
        const sortedSelected = _.sortByOrder(selectedItems, ['id'], ['asc']);
        const sortedOriginal = _.sortByOrder(originalItems, ['id'], ['asc']);
        
        return sortedSelected.some((item, index) => {
            const originalItem = sortedOriginal[index];
            
            // Compare only the specific properties you care about
            return item.id !== originalItem.id ||
                item.dOP !== originalItem.dOP ||
                item.weekNumber !== originalItem.weekNumber ||
                item.dayOfWeek !== originalItem.dayOfWeek ||
                item.timeOfDay !== originalItem.timeOfDay ||
                item.dayCellIndex !== originalItem.dayCellIndex;
            });
    }
    private hasSelectedCalendarChanged(): boolean {
        let calendarInputsChanged = !_.isEqual(_.pick(this.selectedCalendar, ['name', 'lactationGroup', 'startDate', 'startDOP','enrollmentFrequencyCode']), _.pick(this.originalSelectedCalendar, ['name', 'lactationGroup', 'startDate', 'startDOP','enrollmentFrequencyCode'])) || this.selectedLactationGroupOption?.id !== this.originalSelectedLactationGroupOption?.id || this.selectedEnrollmentFrequencyOption?.id !== this.originalSelectedEnrollmentFrequencyOption?.id;
        let calendarItemsChanged = this.hasCalendarItemsChanged();
        return calendarInputsChanged || calendarItemsChanged;
    }

    private routeChange(state) {
            
        if(!this.selectedCalendarHasChanged){
            return true;
        }

        var next = state.to();
        var nextParams = state.params('to');
        var event = state.event;

        this.MSF.confirm({
            title: 'Unsaved Changes',
            message: 'You have unsaved changes to the fertility calendar. Are you sure you want to leave this page and lose those changes?'
        }, () => {
            this.deregTransitionOnStart();
            this.MSF.loadPage(next.name,nextParams);
        });

        return  false;
        
    }

    private validateAllCalendarInputs = (): void => {
        this.selectedCalendarNameIsValid = this.isSelectedCalendarNameValid(this.selectedCalendar.name);
        this.selectedCalendarStartDateIsValid = this.isSelectedCalendarStartDateValid(this.currentCalendarStartDateString);
        this.selectedCalendarStartDOPIsValid = this.isSelectedCalendarStartDOPValid(this.selectedCalendar.startDOP);
        
    }

    private getCurrentCalendarStateSnapshot(): FertilityCalendarState {
        
        return {
            calendar: _.cloneDeep(this.selectedCalendar),
            calendarCollectionIndex: _.findIndex(this.calendars, {id: this.selectedCalendar.id}),
            selectedCalendarOption: _.cloneDeep(this.selectedCalendarOption),
            selectedLactationGroupOption: _.cloneDeep(this.selectedLactationGroupOption),
            calendarOptionIndex: _.findIndex(this.calendarSelectOptions, {id: this.selectedCalendarOption.id}),
            currentCalendarStartDateString: this.currentCalendarStartDateString
        } as FertilityCalendarState;
    }

    private updateCurrentCalendarStateAfterCreate(tempCalendarId: number, newCalendarId: number, updatedNewFertilityCalendarItems: FertilityCalendarItem[]): void {
                
                if(updatedNewFertilityCalendarItems && updatedNewFertilityCalendarItems.length > 0){
                   
                    _.forEach(updatedNewFertilityCalendarItems, (item)=>{
                        const index = _.findIndex(this.selectedCalendar.fertilityCalendarItems, {weekNumber: item.weekNumber, dayOfWeek: item.dayOfWeek, timeOfDay: item.timeOfDay, dOP: item.dOP, dayCellIndex: item.dayCellIndex});
                        if(index !== -1){
                            _.set(this.selectedCalendar.fertilityCalendarItems[index], 'id', item.id);
                            _.set(this.selectedCalendar.fertilityCalendarItems[index], 'herdFertilityCalendarItemId', item.herdFertilityCalendarItemId);
                            _.set(this.selectedCalendar.fertilityCalendarItems[index], 'herdFertilityCalendarId', newCalendarId);
                            
                        }
                    });
                    
                     
                }

                _.set(this.selectedCalendar, 'id', newCalendarId);
                _.set(this.selectedCalendarOption, 'id', newCalendarId);
                _.set(this.selectedCalendarOption,'calendar', this.selectedCalendar);

                const calendarIndex = _.findIndex(this.calendars, {id: tempCalendarId});
                if(calendarIndex !== -1){
                    this.calendars[calendarIndex] = this.selectedCalendar;
                }
                const calendarOptionIndex = _.findIndex(this.calendarSelectOptions, {id: tempCalendarId});
                if(calendarOptionIndex !== -1){
                    _.set(this.calendarSelectOptions[calendarOptionIndex], 'id', newCalendarId);
                    _.set(this.calendarSelectOptions[calendarOptionIndex], 'calendar', this.selectedCalendar);
                }
    }

    private loadCalendarFromState(calendarState: FertilityCalendarState): void {
        this.selectedCalendar = _.cloneDeep(calendarState.calendar);
        // we must seach for the calendar and calendar option in their respective collections because
        // for new calendars via Save As, they are not in those collections yet and we don't want to override 
        // the calendar that was modifed for the save as. 
        const calendarCollectionIndex: number =  _.findIndex(this.calendars, {id: calendarState.calendar.id});
        if(calendarCollectionIndex !== -1){
            this.calendars[calendarCollectionIndex] = calendarState.calendar;
        }else{
            this.calendars = [...this.calendars, calendarState.calendar];
        }
        const calendarOptionIndex: number = _.findIndex(this.calendarSelectOptions, {id: calendarState.selectedCalendarOption.id}); 
        if(calendarOptionIndex !== -1){
            this.selectedCalendarOption = _.cloneDeep(calendarState.selectedCalendarOption);
            this.calendarSelectOptions[calendarOptionIndex] = calendarState.selectedCalendarOption;
        }else{
            this.loadCalendarOptions();
            const newCalendarOptionReference = _.find(this.calendarSelectOptions, {id: calendarState.selectedCalendarOption.id});
            if(newCalendarOptionReference){
                this.selectedCalendarOption = _.cloneDeep(newCalendarOptionReference);
            }
        }
        
        this.selectedLactationGroupOption = _.cloneDeep(calendarState.selectedLactationGroupOption);
        this.currentCalendarStartDateString = calendarState.currentCalendarStartDateString;
    }

    private findExistingCalendar(calendarId: number, calendarName: string): HerdFertilityCalendar|undefined {
          return _.find(this.calendars, (calendar) => calendar.id !== calendarId && this.MSF.isSameString(calendar.name, calendarName));
    }

    private getFormattedCalendarName(calendarName: string): string {
        return this.MSF.getCleanedString(calendarName).replace(/\s+/g, '_');
    }

    private sortFertilityCalendarItems(items: FertilityCalendarItem[]): FertilityCalendarItem[] {
        return _.sortByOrder(items, this.fertilityCalendarItemSortOrder, this.fertilityCalendarItemSortOrderDirection);
    }


    toggleModal(modalId: string): void {
        const modal = $(`#${modalId}`);
        if(_.isUndefined(modal[0])){
            return;
        }
        if(modal.is(':visible')){
            modal.css('display', 'none');
        } else {
            modal.css('display', 'block');
        }
    }

    isSelectedCalendarNameValid(name: string): boolean {
        return !this.MSF.isNullish(name) && name.trim().length > 0;
    }

    isSelectedCalendarStartDateValid(dateString: string): boolean {
        const newStartDateMoment = moment(dateString, 'YYYY-MM-DD', true);
       return newStartDateMoment.isValid();
    }

    isSelectedCalendarStartDOPValid(startDOP: number): boolean {
         const startDOPNumber = _.isNumber(startDOP);
         if(!startDOPNumber){
            return false;
         }
        const startDOPValueGreaterThanZero = startDOP > 0;
        return startDOPValueGreaterThanZero
    }

    isSelectedCalendarEndDateValid(endDateString: string): boolean {
        const endDateMoment = moment(endDateString, 'YYYY-MM-DD');
        const selectedCalendarStartDateMoment = moment(this.currentCalendarStartDateString, 'YYYY-MM-DD');
        const isEndDateAfterStartDate = endDateMoment.isAfter(selectedCalendarStartDateMoment);

       return endDateMoment.isValid() && isEndDateAfterStartDate;
    }

    onExportCalendarAsImage(): void {
        this.ngZone.run(()=>{
            this.isExporting = true;
            this.cdr.detectChanges();
             // Defer the export to the next tick
            setTimeout(() => {
                if(this.selectedCalendar){
                    this.exportService.exportPageAsPng( `${this.getFormattedCalendarName(this.selectedCalendar.name)}.png`, "#mainAppContainer", "Generating Calendar Image...").then(()=>{
                        this.isExporting = false;
                        this.broadcastSvc.exportingMsg(this.isExporting);
                    }).catch((err)=>{
                        this.log.error('Error exporting calendar as image: ' + err);
                        this.isExporting = false;   
                        this.broadcastSvc.exportingMsg(this.isExporting); 
                    });
                }
            }, 0);
        });
    }
    onPrintCalendar(): void {
       // this.ngZone.run(()=>{
            window.print();
      //  });
    }

    

    onUpdateCalendarName(newName: string): void {
        this.selectedCalendarNameIsValid = this.isSelectedCalendarNameValid(newName);
        if(this.selectedCalendar && this.selectedCalendarNameIsValid){
            this.ngZone.run(()=>{
                _.set(this.selectedCalendar, 'name', newName);
                _.set(this.selectedCalendarOption, 'displayText', this.getCalendarDisplayText(this.selectedCalendar));
                this.sortSelectCalendarOptions();
                this.selectedCalendarHasChanged = this.hasSelectedCalendarChanged();
            });
        }   
    }
    
     onCalendarStartDateUpdate(newDateString: string): void {
         const newDateMoment = moment(newDateString, 'YYYY-MM-DD');
         this.selectedCalendarStartDateIsValid = this.isSelectedCalendarStartDateValid(newDateString);
           if(this.selectedCalendar && this.selectedCalendarStartDateIsValid){
               // let calendarToUpdate = _.cloneDeep(this.selectedCalendar);
                //  _.set(this.selectedCalendar, 'startDate', newDateMoment.toDate());
                //  _.set(this.selectedCalendar, 'startDateString', newDateMoment.format('YYYY-MM-DD'));
                //  this.updateSelectedCalendarState(this.selectedCalendar);
                this.updateCalendarPropertyState('startDate', newDateMoment.toDate());
                this.updateCalendarPropertyState('startDateString', newDateMoment.format('YYYY-MM-DD'));
           } 
    }

    
    onCalendarStartDOPUpdate(newStartDOP: number): void {
            this.selectedCalendarStartDOPIsValid = this.isSelectedCalendarStartDOPValid(newStartDOP);
            if(this.selectedCalendar && this.selectedCalendarStartDOPIsValid){
                // let calendarToUpdate = _.cloneDeep(this.selectedCalendar);
                // _.set(this.selectedCalendar, 'startDOP', newStartDOP);
                // this.updateSelectedCalendarState(this.selectedCalendar);
                this.updateCalendarPropertyState('startDOP', newStartDOP);
            }
    }

    onSelectedCalendarEndDateUpdate(newEndDateString: string): void {
        this.ngZone.run(()=>{
            const newEndDateMoment = moment(newEndDateString, 'YYYY-MM-DD');
            if(this.selectedCalendar){
                // _.set(this.selectedCalendar, 'endDate', newEndDateMoment.toDate());
                this.updateCalendarPropertyState('endDate', newEndDateMoment.toDate());
            }
            this.selectedCalendarEndDateIsValid = this.isSelectedCalendarEndDateValid(newEndDateString);
        });
    }

    onCancelCalendarChanges(): void {
        if(this.isCreatingNewCalendar){
            this.calendars = _.reject(this.calendars, {id: this.selectedCalendar.id});
            this.loadCalendarOptions();
            this.isCreatingNewCalendar = false;
        }
        let previousSelectedCalendar = _.cloneDeep(this.originalSelectedCalendar);
        let previousCalendarItemIndex = _.cloneDeep(this.originalCalendarsItemIndex);
        let previousSelectedCalendarOption = _.cloneDeep(this.originalSelectedCalendarOption);
        let previousSelectedCalendarOptionIndex = _.cloneDeep(this.originalSelectedCalendarOptionIndex);
        let previousSelectedLactationGroupOption = _.cloneDeep(this.originalSelectedLactationGroupOption);
        let previousSelectedEnrollmentFrequencyOption = _.cloneDeep(this.originalSelectedEnrollmentFrequencyOption);
        

        
        if(this.calendars.length === 0){
            previousSelectedCalendar = _.cloneDeep(this.placeHolderCalender);
            previousCalendarItemIndex = -1;
            previousSelectedCalendarOption = null;
            previousSelectedCalendarOptionIndex = -1;
            previousSelectedLactationGroupOption = null;
            previousSelectedEnrollmentFrequencyOption = null;
            
        }
        this.selectedCalendar = previousSelectedCalendar;
        if(previousCalendarItemIndex !== -1){
            this.calendars[previousCalendarItemIndex] = previousSelectedCalendar;
            this.calendars = [...this.calendars];
        }
        this.selectedCalendarOption = previousSelectedCalendarOption;
        if(previousSelectedCalendarOptionIndex !== -1){
            this.calendarSelectOptions[previousSelectedCalendarOptionIndex] = previousSelectedCalendarOption;
            this.calendarSelectOptions = [...this.calendarSelectOptions];
        }
        this.selectedLactationGroupOption = previousSelectedLactationGroupOption;

        this.selectedEnrollmentFrequencyOption = previousSelectedEnrollmentFrequencyOption;
        
        this.currentCalendarStartDateString = _.get(this.selectedCalendar, 'startDateString', null);
        this.selectedCalendarHasChanged = false;
    }

    
    onCreateCalendar(): void {
        this.isCreatingNewCalendar = true;
        const newTempCalendarId = this.calendars.length > 0 ? this.getNextTempCalendarId() : this.currentTempCalendarId;
        const newCalendarStartDateMoment = moment().startOf('day');
        const newCalendar: HerdFertilityCalendar = {
            id: newTempCalendarId,
            herdId: this.currentHerdId,
            name: this.defaultCalendarName,
            lactationGroup: _.get(_.find(this.lactationGroupOptions, {groupMemberCode: this.defaultLactationGroupMemberCode}), 'groupMember', ''),
            startDate: newCalendarStartDateMoment.toDate(),
            startDateString: newCalendarStartDateMoment.format('YYYY-MM-DD'),
            startDOP: this.defaultStartDOP,
            enrollmentFrequencyCode: this.defaultEnrollmentFrequencyCode,
            enrollmentFrequency: _.get(_.find(this.enrollmentFrequencyOptions, {code: this.defaultEnrollmentFrequencyCode}), 'codeValue', ''),
            isArchived: false,
            endDate: null,
            endDateString: null,
            archivedDate: null,
            archivedDateString: null,
            fertilityCalendarItems: [],
            isTemplate: false
        };

        const newCalendarOption: FertilityCalendarOption = {
            id: newTempCalendarId,
            isSeparator: false,
            disabled: false,
            displayText: newCalendar.name,
            calendar: newCalendar
        };

        
        this.calendars = [...this.calendars, newCalendar];
        this.loadCalendarOptions();
        this.selectCalendar(newCalendar);
        this.selectedCalendarHasChanged = true;
    }

    saveNonArchivedCalendarAs(): void {
        // before saving we need to clean up the calendar name
        _.set(this.selectedCalendar, 'name', this.MSF.getCleanedString(this.selectedCalendar.name));
        this.updateCalendarPropertyState("name", this.selectedCalendar.name);
        const calendarToSave = _.cloneDeep(this.selectedCalendar);

          this.api.createHerdFertilityCalendar(calendarToSave, (err, updatedNewFertilityCalendarItems)=>{
                if(err){
                    this.log.error(`Error saving fertility calendar as ${calendarToSave.name}: ${err}`);
                    this.MSF.notify.danger("An error occurred while saving the calendar as. Please try again.");
                    return;
                }else{

                    this.MSF.notify.success("Calendar saved successfully.");

                    const newCalendarId = _.get(updatedNewFertilityCalendarItems[0], 'calendarId') as number;
                    this.updateCurrentCalendarStateAfterCreate(calendarToSave.id, newCalendarId, updatedNewFertilityCalendarItems);

                    // temp store saved as calender state
                    const newCalendarStateSnapshot = this.getCurrentCalendarStateSnapshot();

                    // then revert back to the previous calendar which will be in edit mode with the unsaved changes
                    this.onCancelCalendarChanges(); 

                    // then load the newly saved calendar from the temp stored calendar state
                    this.loadCalendarFromState(newCalendarStateSnapshot);

                    // finnally update the original* properties to the newly saved calendar 
                    this.originalSelectedCalendar = _.cloneDeep(this.selectedCalendar);
                    this.originalCalendarsItemIndex = _.findIndex(this.calendars, {id: this.selectedCalendar.id});
                    this.originalSelectedCalendarOption = _.cloneDeep(this.selectedCalendarOption);
                    this.originalSelectedCalendarOptionIndex = _.findIndex(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});
                    this.originalSelectedLactationGroupOption = _.cloneDeep(this.selectedLactationGroupOption);
                    this.originalSelectedEnrollmentFrequencyOption = _.cloneDeep(this.selectedEnrollmentFrequencyOption);
                }
            });
    }

    onCloneCalendar(): void {
        this.isCreatingNewCalendar = true;
        const calendarToClone = _.cloneDeep(this.selectedCalendar);
        const newTempCalendarId = this.calendars.length > 0 ? this.getNextTempCalendarId() : this.currentTempCalendarId;
        _.set(calendarToClone, 'id', newTempCalendarId);
        _.forEach(calendarToClone.fertilityCalendarItems, (item)=>{
            const newTempCalendarItemId = this.getNextTempCalendarItemId();
                _.set(item, 'id', newTempCalendarItemId);
                _.set(item, 'herdId', this.currentHerdId);
                _.set(item, 'herdFertilityCalendarItemId', null);
                _.set(item, 'herdFertilityCalendarId', newTempCalendarId);
        });
        
        _.set(calendarToClone, 'name', 'Copy of '+_.get(this.selectedCalendar, 'name', ''));
        _.set(calendarToClone, 'herdId', this.currentHerdId);
        _.set(calendarToClone, 'isArchived', false);
        _.set(calendarToClone, 'archivedDate', null);
        _.set(calendarToClone, 'archivedDateString', null);
        _.set(calendarToClone, 'endDate', null);
        _.set(calendarToClone, 'endDateString', null);
        _.set(calendarToClone, 'isTemplate', false);
        
        
        this.calendars = [...this.calendars, calendarToClone];
        this.loadCalendarOptions();
        this.selectCalendar(calendarToClone);
        this.selectedCalendarHasChanged = true;
    }
    onSaveCalendarAs(): void {

        // if the selected calendar is an archived calendar , we will create a new calendar with the same properties 
        // as the selected calendar except for the name which will be the default calendar name.
        if(this.selectedCalendar.isArchived){
            this.isCreatingNewCalendar = true;
            const calendarToSaveAs = _.cloneDeep(this.selectedCalendar);
            const newTempCalendarId = this.calendars.length > 0 ? this.getNextTempCalendarId() : this.currentTempCalendarId;
            _.set(calendarToSaveAs, 'id', newTempCalendarId);
            _.forEach(calendarToSaveAs.fertilityCalendarItems, (item)=>{
                const newTempCalendarItemId = this.getNextTempCalendarItemId();
                 _.set(item, 'id', newTempCalendarItemId);
                 _.set(item, 'herdFertilityCalendarItemId', null);
                 _.set(item, 'herdFertilityCalendarId', newTempCalendarId);
            });
            
            _.set(calendarToSaveAs, 'name', this.defaultCalendarName);
            _.set(calendarToSaveAs, 'isArchived', false);
            _.set(calendarToSaveAs, 'archivedDate', null);
            _.set(calendarToSaveAs, 'archivedDateString', null);
            _.set(calendarToSaveAs, 'endDate', null);
            _.set(calendarToSaveAs, 'endDateString', null);
            
            
            this.calendars = [...this.calendars, calendarToSaveAs];
            this.loadCalendarOptions();
            this.selectCalendar(calendarToSaveAs);
            this.selectedCalendarHasChanged = true;


        }else{
            this.validateAllCalendarInputs();
        const calendarHasValidState = this.selectedCalendarNameIsValid && this.selectedCalendarStartDateIsValid && this.selectedCalendarStartDOPIsValid;
        if(!calendarHasValidState){
            return;
        }
            const calendarWithSameName = this.findExistingCalendar(this.selectedCalendar.id, this.selectedCalendar.name);
            if(!_.isUndefined(calendarWithSameName)){
                const replacedCalendarId = _.get(calendarWithSameName, 'id') as number;
                this.MSF.confirm({
                    title: 'Overwrite Existing Calendar?',
                    message: `Another calendar with the name "${this.selectedCalendar.name}" already exists. If you select "Yes", the existing calendar with the duplicate name will be permanently deleted and replaced with the current calendar changes.`,
                    confirm:{
                        text: 'Yes, Overwrite',
                        className: 'success'
                    },
                    cancel:{
                        text: 'Cancel',
                        className: 'default'
                    }
                }, () => { // confirmation
                    this.deleteCalendar(replacedCalendarId).then((success)=>{
                        this.calendars = _.reject(this.calendars, {id: replacedCalendarId});
                        this.calendarSelectOptions = _.reject(this.calendarSelectOptions, {id: replacedCalendarId});
                        this.saveNonArchivedCalendarAs();
                    
                    }, (err)=>{
                        this.MSF.notify.danger("An error occurred while overwriting the existing calendar with the duplicate name. Please try saving again.");
                    });
                });
                
            }else{
                this.saveNonArchivedCalendarAs();
            }
          
        }

    }

    deleteCalendar(calendarId: number): Promise<boolean> {
        return new Promise((resolve, reject)=>{
            this.api.deleteHerdFertilityCalendar(calendarId, this.currentHerdId, (err, result)=>{
                if(err){
                    this.log.error(`Error deleting fertility calendar with id ${calendarId}: ${err}`);
                    reject(err);
                }else{
                    resolve(result);
                }
            });
        })    
    }

    saveCalendarChanges(): void {
        

        const calendarToSave = _.cloneDeep(this.selectedCalendar);
        // before saving we need to clean up the calendar name
        const cleanedCalendarName = this.MSF.getCleanedString(this.selectedCalendar.name);
        _.set(calendarToSave, 'name', cleanedCalendarName);
        if(this.isCreatingNewCalendar){

            this.api.createHerdFertilityCalendar(calendarToSave, (err, createCalendarResult)=>{
                if(err){
                    this.log.error(`Error creating fertility calendar ${calendarToSave.name}: ${err}`);
                    this.MSF.notify.danger("An error occurred while creating the calendar. Please try again.");
                    this.isSavingChanges = false;
                    return;
                }
                
                // the new fertility calendar items will need their id and herdFertilityCalendarItemId updated
                const newCalendarId = _.get(createCalendarResult[0], 'calendarId') as number;
                let updatedNewFertilityCalendarItems: FertilityCalendarItem[] = [];
                try {
                    updatedNewFertilityCalendarItems = _.map(JSON.parse(_.get(createCalendarResult[0], 'fertilityCalendarItemsJSON', '[]')),this.MSF.lowerCaseObjectKeys) as FertilityCalendarItem[];
                } catch (error) {
                    this.log.error(`Error parsing fertility calendar items JSON for calendar ${calendarToSave.name}: ${error}`);
                } 

                this.updateCurrentCalendarStateAfterCreate(calendarToSave.id, newCalendarId, updatedNewFertilityCalendarItems);
                
                this.selectedCalendar = {...this.selectedCalendar} as HerdFertilityCalendar; // trigger change detection for the selected calendar
                this.isCreatingNewCalendar = false;
                this.originalSelectedCalendar = _.cloneDeep(this.selectedCalendar);
                this.originalCalendarsItemIndex = _.findIndex(this.calendars, {id: this.selectedCalendar.id});
                this.originalSelectedCalendarOption = _.cloneDeep(this.selectedCalendarOption);
                this.originalSelectedCalendarOptionIndex = _.findIndex(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});
                this.originalSelectedLactationGroupOption = _.cloneDeep(this.selectedLactationGroupOption);
                this.originalSelectedEnrollmentFrequencyOption = _.cloneDeep(this.selectedEnrollmentFrequencyOption);
                this.selectedCalendarHasChanged = false;
                this.isSavingChanges = false;
                this.MSF.notify.success("Calendar created successfully.");

            });

        }else{
            this.api.updateHerdFertilityCalendar(calendarToSave, (err, updatedNewFertilityCalendarItems)=>{
                if(err){
                    this.log.error(`Error saving fertility calendar ${calendarToSave.name}: ${err}`);
                    this.MSF.notify.danger("An error occurred while saving the calendar. Please try again.");
                    this.isSavingChanges = false;
                    return;
                }
                this.MSF.notify.success("Calendar saved successfully.");

                // any new fertility calendar items that were added will need their id and herdFertilityCalendarItemId updated
                if(updatedNewFertilityCalendarItems && updatedNewFertilityCalendarItems.length > 0){
                    _.forEach(updatedNewFertilityCalendarItems, (item)=>{
                        const index = _.findIndex(this.selectedCalendar.fertilityCalendarItems, {weekNumber: item.weekNumber, dayOfWeek: item.dayOfWeek, timeOfDay: item.timeOfDay, dOP: item.dOP, dayCellIndex: item.dayCellIndex});
                        if(index !== -1){
                            _.set(this.selectedCalendar.fertilityCalendarItems[index], 'id', item.id);
                            _.set(this.selectedCalendar.fertilityCalendarItems[index], 'herdFertilityCalendarItemId', item.herdFertilityCalendarItemId);
                        }
                    });
                }
                
                this.updateCalendarPropertiesState({name: cleanedCalendarName, fertilityCalendarItems: this.selectedCalendar.fertilityCalendarItems});
                this.updateCalendarOriginalsPropertyState();
                this.selectedCalendarHasChanged = false;
                this.isSavingChanges = false;
            });
        }
    }
    onSaveCalendarChanges(): void {
      // console.log("saving calendar changes!!!!");
        this.isSavingChanges = true;
        this.validateAllCalendarInputs();
        const calendarHasValidState = this.selectedCalendarNameIsValid && this.selectedCalendarStartDateIsValid && this.selectedCalendarStartDOPIsValid;
        if(!calendarHasValidState){
            this.isSavingChanges = false;
            return;
        }
        
        const calendarWithSameName = this.findExistingCalendar(this.selectedCalendar.id, this.selectedCalendar.name);
        
        if(!_.isUndefined(calendarWithSameName)){
            const replacedCalendarId = _.get(calendarWithSameName, 'id') as number;
            this.MSF.confirm({
                title: 'Overwrite Existing Calendar?',
                message: `Another calendar with the name "${this.selectedCalendar.name}" already exists. If you select "Yes", the existing calendar with the duplicate name will be permanently deleted and replaced with the current calendar changes.`,
                confirm:{
                    text: 'Yes, Overwrite',
                    className: 'success'
                },
                cancel:{
                    text: 'Cancel',
                    className: 'default'
                }
            }, () => { // confirmation
                 this.deleteCalendar(replacedCalendarId).then((success)=>{

                    this.calendars = _.reject(this.calendars, {id: replacedCalendarId});
                    this.calendarSelectOptions = _.reject(this.calendarSelectOptions, {id: replacedCalendarId});

                    this.saveCalendarChanges();

                 }, (err)=>{
                    this.MSF.notify.danger("An error occurred while overwriting the existing calendar with the duplicate name. Please try saving again.");
                    this.isSavingChanges = false;
                 })
            }, () => { // cancellation
                this.isSavingChanges = false;
            });
        }else{
            this.saveCalendarChanges();
        }

        
    }

    private updateCalendarPropertyState(propertyName: string, newValue: any): void {
        _.set(this.selectedCalendar, propertyName, newValue);
        const calendarItemRef = _.find(this.calendars, {id: this.selectedCalendar.id});
        if(calendarItemRef){
            _.set(calendarItemRef, propertyName, newValue);
        }
        const calendarOptionRef = _.find(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});
        if(calendarOptionRef){
            _.set(calendarOptionRef.calendar, propertyName, newValue);
        }

        this.selectedCalendar = _.cloneDeep(this.selectedCalendar);
        
        _.set(this.selectedCalendarOption, 'displayText', this.getCalendarDisplayText(this.selectedCalendar));
   
        this.selectedCalendarHasChanged = this.hasSelectedCalendarChanged();
    }

    private updateCalendarPropertiesState(updatedProperties:any): void {
        _.merge(this.selectedCalendar, updatedProperties);
        const calendarItemRef = _.find(this.calendars, {id: this.selectedCalendar.id});
        if(calendarItemRef){
            _.merge(calendarItemRef, updatedProperties);
        }
        const calendarOptionRef = _.find(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});
        if(calendarOptionRef){
            _.merge(calendarOptionRef.calendar, updatedProperties);
        }
        this.selectedCalendar = _.cloneDeep(this.selectedCalendar);
        _.set(this.selectedCalendarOption, 'displayText', this.getCalendarDisplayText(this.selectedCalendar));
        this.selectedCalendarHasChanged = this.hasSelectedCalendarChanged();
    }


    private updateCalendarOriginalsPropertyState(): void {
            this.originalSelectedCalendar = _.cloneDeep(this.selectedCalendar);
            this.originalCalendarsItemIndex = _.findIndex(this.calendars, {id: this.selectedCalendar.id});
            this.originalSelectedCalendarOption = _.cloneDeep(this.selectedCalendarOption);
            this.originalSelectedCalendarOptionIndex = _.findIndex(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});
            this.originalSelectedLactationGroupOption = _.cloneDeep(this.selectedLactationGroupOption);
            this.originalSelectedEnrollmentFrequencyOption = _.cloneDeep(this.selectedEnrollmentFrequencyOption);
    }
    

    onArchiveCalendar(): void {
        // validate other inputs first to ensure the calendar is in a valid state before allowing the user to archive it
        this.validateAllCalendarInputs();
       
        // Then validate the end date specific to archiving the calendar
        this.selectedCalendarEndDateIsValid = this.isSelectedCalendarEndDateValid(this.selectedCalendar.endDateString);
       
        const calendarHasValidState = this.selectedCalendarNameIsValid && this.selectedCalendarStartDateIsValid && this.selectedCalendarStartDOPIsValid && this.selectedCalendarEndDateIsValid;
        if(!calendarHasValidState){
            return;
        }

        const calendarToArchive = _.cloneDeep(this.selectedCalendar);
        const calendarId = _.get(calendarToArchive, 'id');
        const herdId = this.currentHerdId;
        const calendarEndDate = _.get(calendarToArchive, 'endDate');
        this.api.archiveHerdFertilityCalendar(calendarId, herdId, calendarEndDate, (err, updatedCalendarArchiveInfo)=>{
            if(err){
                this.log.error(`Error archiving fertility calendar ${calendarToArchive.name}: ${err}`);
                this.MSF.notify.danger("An error occurred while archiving the calendar. Please try again.");
                return;
            }

                this.MSF.notify.success("Calendar archived successfully.");

                if(!this.MSF.isNullish(updatedCalendarArchiveInfo)){
                    const calendarArchivedDateString = _.get(updatedCalendarArchiveInfo, 'archivedDate');
                    const calendarArchivedDate = moment(calendarArchivedDateString, 'YYYY-MM-DD').toDate();
                    this.updateCalendarPropertyState('endDate', calendarEndDate);
                    this.updateCalendarPropertyState('endDateString', moment(calendarEndDate).format('YYYY-MM-DD'));
                    this.updateCalendarPropertyState('isArchived', true);
                    this.updateCalendarPropertyState('archivedDate', calendarArchivedDate);
                    this.updateCalendarPropertyState('archivedDateString', moment(calendarArchivedDate).format('YYYY-MM-DD'));
                    this.loadCalendarOptions();
                    
                    // update original* properties to reflect the archived state since that is the new persisted state of the calendar
                    this.originalSelectedCalendar = _.cloneDeep(this.selectedCalendar);
                    this.originalCalendarsItemIndex = _.findIndex(this.calendars, {id: this.selectedCalendar.id});
                    this.originalSelectedCalendarOption = _.cloneDeep(this.selectedCalendarOption);
                    this.originalSelectedCalendarOptionIndex = _.findIndex(this.calendarSelectOptions, {id: this.selectedCalendarOption.id});
                    this.originalSelectedLactationGroupOption = _.cloneDeep(this.selectedLactationGroupOption);
                    this.originalSelectedEnrollmentFrequencyOption = _.cloneDeep(this.selectedEnrollmentFrequencyOption);
                }

                this.toggleModal('archiveCalendarModal');


        });
       
    }

    onCancelArchiveCalendar(): void {
        this.updateCalendarPropertyState('endDate', null);
        this.updateCalendarPropertyState('endDateString', null);
        this.toggleModal('archiveCalendarModal');
    }


    onCalendarItemAdded(eventData:[FertilityCalendarItem, FertilityCalendarItem[]]): void {
        const [newItem, affectedFertilityCalendarItems] = eventData;
      //  console.log("calendar item added:", affectedFertilityCalendarItems, newItem);

        _.forEach(affectedFertilityCalendarItems, (item)=>{
            let existingFertilityCalendarItem = _.find(this.selectedCalendar.fertilityCalendarItems, {id: item.id});
            if(existingFertilityCalendarItem){
                _.merge(existingFertilityCalendarItem, item);
            }
        }); 
        const updatedFerilityCalendarItems = this.sortFertilityCalendarItems([...this.selectedCalendar.fertilityCalendarItems, newItem]);
        this.updateCalendarPropertyState('fertilityCalendarItems', updatedFerilityCalendarItems);
    }
    onCalendarItemRemoved(eventData:[FertilityCalendarItem[], FertilityCalendarItem[]]): void {
        const [removedFertilityCalendarItems, affectedFertilityCalendarItems] = eventData;
     //   console.log("calendar item removed:", removedFertilityCalendarItems, affectedFertilityCalendarItems);

        let  updatedFerilityCalendarItems: FertilityCalendarItem[] = [];
        updatedFerilityCalendarItems =  _.reject(this.selectedCalendar.fertilityCalendarItems, (item) => _.some(removedFertilityCalendarItems, {id: item.id}));
        _.forEach(affectedFertilityCalendarItems, (item)=>{
            let existingFertilityCalendarItem = _.find(updatedFerilityCalendarItems, {id: item.id});
            if(existingFertilityCalendarItem){
                _.merge(existingFertilityCalendarItem, item);
            }
        });
        updatedFerilityCalendarItems = this.sortFertilityCalendarItems([...updatedFerilityCalendarItems]);
        this.updateCalendarPropertyState('fertilityCalendarItems', updatedFerilityCalendarItems);
    }
    onCalendarItemMoved(eventData:[FertilityCalendarItem, FertilityCalendarItem[]]): void {
        const [movedItem, affectedFertilityCalendarItems] = eventData;
      //  console.log("calendar item moved:", affectedFertilityCalendarItems, movedItem);
      
        _.forEach(affectedFertilityCalendarItems, (item)=>{
            let existingFertilityCalendarItem = _.find(this.selectedCalendar.fertilityCalendarItems, {id: item.id});
            if(existingFertilityCalendarItem){
                _.merge(existingFertilityCalendarItem, item);
            }
        });
        const updatedFerilityCalendarItems = this.sortFertilityCalendarItems([...this.selectedCalendar.fertilityCalendarItems]);
        this.updateCalendarPropertyState('fertilityCalendarItems', updatedFerilityCalendarItems);
    }

    onCalendarItemSorted(fertilityCalendarItems:FertilityCalendarItem[]): void {
       // console.log("calendar items sorted:", fertilityCalendarItems);
 
        _.forEach(fertilityCalendarItems, (item)=>{
            let existingFertilityCalendarItem = _.find(this.selectedCalendar.fertilityCalendarItems, {id: item.id});
            if(existingFertilityCalendarItem){
                _.merge(existingFertilityCalendarItem, item);
            }
        });
        const updatedFerilityCalendarItems = this.sortFertilityCalendarItems([...this.selectedCalendar.fertilityCalendarItems]);
        this.updateCalendarPropertyState('fertilityCalendarItems', updatedFerilityCalendarItems);
      
    }

    onCalendarInputChanged(fertilityCalendarItems:FertilityCalendarItem[]): void {
       // console.log("calendar input changed:", fertilityCalendarItems);
        _.forEach(fertilityCalendarItems, (item)=>{
            let existingFertilityCalendarItem = _.find(this.selectedCalendar.fertilityCalendarItems, {id: item.id});
            if(existingFertilityCalendarItem){
                _.merge(existingFertilityCalendarItem, item);
            }
        });
        const updatedFerilityCalendarItems = this.sortFertilityCalendarItems([...this.selectedCalendar.fertilityCalendarItems]);
        this.updateCalendarPropertyState('fertilityCalendarItems', updatedFerilityCalendarItems);
    }
    

}